import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-methodology2',
  templateUrl: './methodology2.component.html',
  styleUrls: ['./methodology2.component.scss']
})
export class Methodology2Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
